// eslint-disable-next-line @typescript-eslint/no-explicit-any
const env = (window as any).__ENV;

if (!env) {
  throw new Error("Runtime config not loaded.");
}

export const runtimeConfig = {
  api: {
    tenantId: env.API_TENANT_ID || "",
    baseUrl: env.API_BASE_URL || "",
  },
  auth: {
    authority: env.AUTH_AUTHORITY,
    clientId: env.AUTH_CLIENT_ID,
  }
};